<template>
  <button class="secondary-btn flex items-center gap-1.5 px-2 py-1.5 rounded-md"
  :disabled="loading" :class="{'disabled': loading}"
  @click="$emit('authenticate')">
    <BaseLoadingSpinnerCircle v-if="loading" :duration="1.2" class="text-icon-disabled" />
    <component v-else :is="icon" class="text-icon-normal" />
    <BaseText type="label" size="sm">
      Add New {{ platformName }} Account
    </BaseText>
  </button>
</template>

<script>
export default {
  name: 'AddLensPlatformAccountButton',
  props: {
    platformName: {
      type: String,
      required: true
    },
    icon: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.secondary-btn {
  box-shadow: 0 1px 2px 0 rgba(4, 26, 75, 0.13), 0 0 0 1px rgba(0, 56, 108, 0.08);
  background-color: white;
  color: #303546;
  transition: box-shadow 100ms ease-in-out, background-color 100ms ease-in-out, color 100ms ease-in-out;
}
.secondary-btn:hover, .secondary-btn.disabled {
  box-shadow: none;
  background-color: #F6F8FA;
}
.secondary-btn.disabled {
  color: #A4ABB8;
  cursor: default;
}
</style>